/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { AuditLogDto } from './AuditLogDto';
import {
    AuditLogDtoFromJSON,
    AuditLogDtoFromJSONTyped,
    AuditLogDtoToJSON,
    AuditLogDtoToJSONTyped,
} from './AuditLogDto';

/**
 * Response containing a single audit log entry
 * @export
 * @interface AuditLogResponse
 */
export interface AuditLogResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditLogResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof AuditLogResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof AuditLogResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof AuditLogResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * The audit log entry data
     * @type {AuditLogDto}
     * @memberof AuditLogResponse
     */
    data?: AuditLogDto;
}

/**
 * Check if a given object implements the AuditLogResponse interface.
 */
export function instanceOfAuditLogResponse(value: object): value is AuditLogResponse {
    return true;
}

export function AuditLogResponseFromJSON(json: any): AuditLogResponse {
    return AuditLogResponseFromJSONTyped(json, false);
}

export function AuditLogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditLogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : AuditLogDtoFromJSON(json['data']),
    };
}

export function AuditLogResponseToJSON(json: any): AuditLogResponse {
    return AuditLogResponseToJSONTyped(json, false);
}

export function AuditLogResponseToJSONTyped(value?: AuditLogResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': AuditLogDtoToJSON(value['data']),
    };
}

